var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Log_Out",
    width: 24,
    height: 24,
    "data-name": "Icon - Log Out",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}.prefix__cls-4{fill:none;stroke:#ffc001;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0h24v24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Log_Out-2",
    "data-name": "Icon - Log Out",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0h16v16H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3604",
    "data-name": "Group 3604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1739",
    fill: "#11763b",
    d: "M1.2 0h9.625a1.174 1.174 0 0 1 1.2 1.143v13.714A1.174 1.174 0 0 1 10.828 16H1.2A1.174 1.174 0 0 1 0 14.857V1.143A1.174 1.174 0 0 1 1.2 0z",
    "data-name": "Rectangle 1739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1738",
    fill: "#ffc001",
    d: "M22.5 15.25a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75z",
    "data-name": "Rectangle 1738",
    transform: "translate(-7.469 -7.25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3517",
    "data-name": "Group 3517",
    transform: "translate(13.5 6.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_117",
    d: "M1.75 0L0 1.75",
    className: "prefix__cls-4",
    "data-name": "Line 117",
    transform: "translate(0 1.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_118",
    d: "M1.75 1.75L0 0",
    className: "prefix__cls-4",
    "data-name": "Line 118"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1740",
    fill: "#0baf50",
    d: "M1.125 0h6.75A1.134 1.134 0 0 1 9 1.143v13.714A1.134 1.134 0 0 1 7.875 16h-6.75A1.134 1.134 0 0 1 0 14.857V1.143A1.134 1.134 0 0 1 1.125 0z",
    "data-name": "Rectangle 1740"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_1767",
    width: 1.5,
    height: 3.5,
    fill: "#fff",
    "data-name": "Rectangle 1767",
    rx: 0.75,
    transform: "translate(6.5 6.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogOut);
export default __webpack_public_path__ + "static/media/icon-log-out.9fa888f31ff562573f077a627cd746f8.svg";
export { ForwardRef as ReactComponent };